import { CloudServerOutlined, FontColorsOutlined } from "@ant-design/icons";
import { lazy } from "react";
import { permissionCodeConstant } from "../utils/permissionConstant";
import { create } from "qrcode";
import { patch } from "../api/restApi";

export const warehouseManagementStaticPath = {
  warehouseReceipt: "/stock/warehouse-receipt",
  createStockReceipt: "/stock/warehouse-receipt/create",
  updateStockReceipt: "/stock/warehouse-receipt/update",
  approveStockReceipt: "/stock/warehouse-receipt/approve",

  usedWarehouseDelivery: "/stock/used-warehouse-delivery",
  usedWarehouseDeliveryCreate: "/stock/used-warehouse-delivery/create",
  usedWarehouseDeliveryUpdate: "/stock/used-warehouse-delivery/update",
  usedWarehouseDeliveryApproved: "/stock/used-warehouse-delivery/approve",

  liquidationWarehouseReceipt: "/stock/liquidation-warehouse-receipt",
  liquidationWarehouseReceiptCreate:
    "/stock/liquidation-warehouse-receipt/create",
  liquidationWarehouseReceiptUpdate:
    "/stock/liquidation-warehouse-receipt/update",
  liquidationWarehouseReceiptApproved:
    "/stock/liquidation-warehouse-receipt/approve",

  equipmenWarehouse: "/stock/equipmen-warehouse",
  sparePartsComponentsWarehouse: "/stock/spare-parts-components-warehouse",
  stockLocation: "/stock/stockLocation",
  warehouseAwaitingLiquidation: "/stock/warehouse-awaiting-liquidation",
  machineCancellationRequest: "/stock/machine-cancellation-request",
  createMachineCancellationRequest:
    "/stock/machine-cancellation-request/create",
  updateMachineCancellationRequest:
    "/stock/machine-cancellation-request/update",
  viewMachineCancellationRequest: "/stock/machine-cancellation-request/view",
  returnDevice: "/stock/return-device",
  createReturnDevice: "/stock/return-device/create",
  updateReturnDevice: "/stock/return-device/update",
  viewReturnDevice: "/stock/return-device/view",
};

export const routeWarehouseManagements = [
  // {
  //   path: warehouseManagementStaticPath.stockLocation,
  //   exact: true,
  //   show_menu: true,
  //   icon: <CloudServerOutlined />,
  //   key: warehouseManagementStaticPath.stockLocation,
  //   label: "Danh sách kho",
  //   component: lazy(() => import("../pages/purchase/stockLocation")),
  //   un_check_permission: true, // chưa check
  // },
  {
    path: warehouseManagementStaticPath.machineCancellationRequest,
    exact: true,
    show_menu: true,
    icon: <CloudServerOutlined />,
    key: warehouseManagementStaticPath.machineCancellationRequest,
    label: "machine_cancellation_request.menu",
    component: lazy(
      () => import("../pages/warehouseManagement/machineCancellationRequest"),
    ),
    permisisonCode: permissionCodeConstant.machine_cancellation_request_view_list,
  },
  {
    path: warehouseManagementStaticPath.createMachineCancellationRequest,
    exact: true,
    show_menu: false,
    icon: <CloudServerOutlined />,
    key: warehouseManagementStaticPath.createMachineCancellationRequest,
    label: "Thêm mới đề nghị hủy tài sản",
    component: lazy(
      () =>
        import("../pages/warehouseManagement/machineCancellationRequest/CreateMachineCancellationRequest"),
    ),
    permisisonCode: permissionCodeConstant.machine_cancellation_request_create,
  },
  {
    path: warehouseManagementStaticPath.viewMachineCancellationRequest + "/:id",
    exact: true,
    show_menu: false,
    icon: <CloudServerOutlined />,
    key: warehouseManagementStaticPath.viewMachineCancellationRequest + "/:id",
    label: "Xem chi tiết đề nghị hủy tài sản",
    component: lazy(
      () =>
        import("../pages/warehouseManagement/machineCancellationRequest/ViewMachineCancellationRequest"),
    ),
    permisisonCode: permissionCodeConstant.machine_cancellation_request_view_list,
  },
  {
    path:
      warehouseManagementStaticPath.updateMachineCancellationRequest + "/:id",
    exact: true,
    show_menu: false,
    icon: <CloudServerOutlined />,
    key:
      warehouseManagementStaticPath.updateMachineCancellationRequest + "/:id",
    label: "Cập nhật đề nghị hủy tài sản",
    component: lazy(
      () =>
        import("../pages/warehouseManagement/machineCancellationRequest/UpdateMachineCancellationRequest"),
    ),
    permisisonCode: permissionCodeConstant.machine_cancellation_request_update,
  },
  {
    path: warehouseManagementStaticPath.returnDevice,
    exact: true,
    show_menu: true,
    icon: <CloudServerOutlined />,
    key: warehouseManagementStaticPath.returnDevice,
    label: "return_device.menu",
    component: lazy(() => import("../pages/warehouseManagement/returnDevice")),
    permisisonCode: permissionCodeConstant.return_device_view_list, //chưa check
  },
  {
    path: warehouseManagementStaticPath.createReturnDevice,
    exact: true,
    show_menu: false,
    icon: <CloudServerOutlined />,
    key: warehouseManagementStaticPath.createReturnDevice,
    label: "Thêm mới đề nghị trả tài sản",
    component: lazy(
      () =>
        import("../pages/warehouseManagement/returnDevice/CreateReturnDevice"),
    ),
    permisisonCode: permissionCodeConstant.return_device_create, //chưa check
  },
  {
    path: warehouseManagementStaticPath.viewReturnDevice + "/:id",
    exact: true,
    show_menu: false,
    icon: <CloudServerOutlined />,
    key: warehouseManagementStaticPath.viewReturnDevice + "/:id",
    label: "Xem chi tiết đề nghị trả tài sản",
    component: lazy(
      () =>
        import("../pages/warehouseManagement/returnDevice/ViewReturnDevice"),
    ),
    permisisonCode: permissionCodeConstant.return_device_view_list, //chưa check
  },
  {
    path: warehouseManagementStaticPath.updateReturnDevice + "/:id",
    exact: true,
    show_menu: false,
    icon: <CloudServerOutlined />,
    key: warehouseManagementStaticPath.updateReturnDevice + "/:id",
    label: "Cập nhật đề nghị trả tài sản",
    component: lazy(
      () =>
        import("../pages/warehouseManagement/returnDevice/UpdateReturnDevice"),
    ),
    permisisonCode: permissionCodeConstant.return_device_update, //chưa check
  },
  {
    path: warehouseManagementStaticPath.warehouseAwaitingLiquidation,
    exact: true,
    show_menu: true,
    icon: <CloudServerOutlined />,
    key: warehouseManagementStaticPath.warehouseAwaitingLiquidation,
    label: "Kho chờ thanh lý",
    component: lazy(
      () => import("../pages/purchase/warehouseAwaitingLiquidation"),
    ),
    // permisisonCode: permissionCodeConstant.warehouse_awaiting_liquidation_asset_view,
    un_check_permission: true
  },
  {
    path: warehouseManagementStaticPath.equipmenWarehouse,
    exact: true,
    show_menu: true,
    icon: <CloudServerOutlined />,
    key: warehouseManagementStaticPath.equipmenWarehouse,
    label: "menu.warehouse_management.equipmen_warehouse",
    component: lazy(
      () => import("../pages/purchase/inventory/AssetsInventory"),
    ),
    permisisonCode: permissionCodeConstant.inventory_assets,
  },
  {
    path: warehouseManagementStaticPath.warehouseReceipt,
    exact: true,
    show_menu: true,
    icon: <CloudServerOutlined />,
    key: warehouseManagementStaticPath.warehouseReceipt,
    label: "menu.warehouse_management.warehouse_receipt",
    component: lazy(() => import("../pages/purchase/receiptPurchase")),
    permisisonCode: permissionCodeConstant.stock_receipt_view_request,
  },
  {
    path: warehouseManagementStaticPath.createStockReceipt,
    exact: true,
    show_menu: false,
    key: warehouseManagementStaticPath.createStockReceipt,
    label: "Thêm mới phiếu nhập kho",
    component: lazy(
      () => import("../pages/purchase/receiptPurchase/CreateReceiptPurchase"),
    ),
    un_check_permission: true,
  },
  {
    path: warehouseManagementStaticPath.updateStockReceipt + "/:id",
    exact: true,
    show_menu: false,
    key: warehouseManagementStaticPath.updateStockReceipt + "/:id",
    label: "update phiếu nhập kho",
    component: lazy(
      () => import("../pages/purchase/receiptPurchase/UpdateReceiptPurchase"),
    ),
    un_check_permission: true,
  },
  {
    path: warehouseManagementStaticPath.approveStockReceipt + "/:id",
    exact: true,
    show_menu: false,
    key: warehouseManagementStaticPath.approveStockReceipt + "/:id",
    label: "update phiếu nhập kho",
    component: lazy(
      () => import("../pages/purchase/receiptPurchase/approveReceiptPurchase"),
    ),
    un_check_permission: true,
  },
  {
    path: warehouseManagementStaticPath.usedWarehouseDelivery,
    exact: true,
    show_menu: true,
    icon: <CloudServerOutlined />,
    key: warehouseManagementStaticPath.usedWarehouseDelivery,
    label: "menu.warehouse_management.used_warehouse_delivery",
    component: lazy(
      () => import("../pages/warehouseManagement/usedWarehouseDelivery"),
    ),
    permisisonCode: permissionCodeConstant.stock_issue_use_view_request,
  },
  {
    path: warehouseManagementStaticPath.usedWarehouseDeliveryCreate,
    exact: true,
    show_menu: false,
    key: warehouseManagementStaticPath.usedWarehouseDeliveryCreate,
    label: "Xuất kho sử dụng",
    component: lazy(
      () =>
        import("../pages/warehouseManagement/usedWarehouseDelivery/CreateReceiptIssue"),
    ),
    un_check_permission: true,
  },
  {
    path: warehouseManagementStaticPath.usedWarehouseDeliveryUpdate + "/:id",
    exact: true,
    show_menu: false,
    key: warehouseManagementStaticPath.usedWarehouseDeliveryUpdate + "/:id",
    label: "Xuất kho ",
    component: lazy(
      () =>
        import("../pages/warehouseManagement/usedWarehouseDelivery/UpdateReceiptIssue"),
    ),
    un_check_permission: true,
  },
  {
    path: warehouseManagementStaticPath.usedWarehouseDeliveryApproved + "/:id",
    exact: true,
    show_menu: false,
    key: warehouseManagementStaticPath.usedWarehouseDeliveryApproved + "/:id",
    label: "Xuất kho ",
    component: lazy(
      () =>
        import("../pages/warehouseManagement/usedWarehouseDelivery/ApprovalReceiptIssue"),
    ),
    un_check_permission: true,
  },
  {
    path: warehouseManagementStaticPath.liquidationWarehouseReceipt,
    exact: true,
    show_menu: true,
    icon: <CloudServerOutlined />,
    key: warehouseManagementStaticPath.liquidationWarehouseReceipt,
    label: "menu.warehouse_management.liquidation receipt",
    component: lazy(
      () => import("../pages/warehouseManagement/liquidationWarehouseReceipt"),
    ),
    permisisonCode: permissionCodeConstant.stock_issue_liquidation_view_request,
  },
  {
    path: warehouseManagementStaticPath.liquidationWarehouseReceiptCreate,
    exact: true,
    show_menu: false,
    key: warehouseManagementStaticPath.liquidationWarehouseReceiptCreate,
    label: "Xuất kho thanh lý",
    component: lazy(
      () =>
        import("../pages/warehouseManagement/liquidationWarehouseReceipt/CreateReceiptIssue"),
    ),
    un_check_permission: true,
  },
  {
    path:
      warehouseManagementStaticPath.liquidationWarehouseReceiptUpdate + "/:id",
    exact: true,
    show_menu: false,
    key:
      warehouseManagementStaticPath.liquidationWarehouseReceiptUpdate + "/:id",
    label: "Xuất kho ",
    component: lazy(
      () =>
        import("../pages/warehouseManagement/liquidationWarehouseReceipt/UpdateReceiptIssue"),
    ),
    un_check_permission: true,
  },
  {
    path:
      warehouseManagementStaticPath.liquidationWarehouseReceiptApproved +
      "/:id",
    exact: true,
    show_menu: false,
    key:
      warehouseManagementStaticPath.liquidationWarehouseReceiptApproved +
      "/:id",
    label: "Xuất kho ",
    component: lazy(
      () =>
        import("../pages/warehouseManagement/liquidationWarehouseReceipt/ApprovalReceiptIssue"),
    ),
    un_check_permission: true,
  },
  // {
  //     path: warehouseManagementStaticPath.createReceiptIssue,
  //     exact: true,
  //     show_menu: false,
  //     key: warehouseManagementStaticPath.createReceiptIssue,
  //     label: "Xuất kho ",
  //     component: lazy(() => import("../pages/purchase/ReceiptIssue/CreateReceiptIssue")),

  // },
  // {
  //     path: warehouseManagementStaticPath.updateReceiptIssue + "/:id",
  //     exact: true,
  //     show_menu: false,
  //     key: warehouseManagementStaticPath.updateReceiptIssue + "/:id",
  //     label: "Xuất kho ",
  //     component: lazy(() => import("../pages/purchase/ReceiptIssue/UpdateReceiptIssue")),
  // },
  // {
  //     path: warehouseManagementStaticPath.approvalReceiptIssue + "/:id",
  //     exact: true,
  //     show_menu: false,
  //     key: warehouseManagementStaticPath.approvalReceiptIssue + "/:id",
  //     label: "Xuất kho ",
  //     component: lazy(() => import("../pages/purchase/ReceiptIssue/ApprovalReceiptIssue"))
  // },
  {
    path: warehouseManagementStaticPath.sparePartsComponentsWarehouse,
    exact: true,
    show_menu: true,
    icon: <CloudServerOutlined />,
    key: warehouseManagementStaticPath.sparePartsComponentsWarehouse,
    label: "menu.warehouse_management.spare_parts_components_warehouse",
    component: lazy(
      () => import("../pages/purchase/inventory/SparePartsIventory"),
    ),
    permisisonCode: permissionCodeConstant.inventory_spareparts,
  },
];
